import { ChevronRightIcon } from "../icons";
import cx from "classnames";

export function ReadmoreButton(props: {
  as?: string,
  onClick?: Function,
  className: string,
  children: any
}) {
  let Tag = "button" as keyof JSX.IntrinsicElements;
  if (props.as && props.as != "button") {
    Tag = props.as as keyof JSX.IntrinsicElements;
  }

  return (
    <Tag onClick={props.onClick} className={cx("swt-hover-primary", props.className)}>
      <span className="flex items-center gap-0.5">
        <span className="">{props.children}</span>
        <ChevronRightIcon className="pt-px scale-125" fw />
      </span>
    </Tag>
  )
}
